import React from 'react';

function CompletedScreen({ 
  title = "Evaluation Completed", 
  message = "You have successfully completed this evaluation.", 
  onContinue,
  continueButtonText = "Continue"
}) {
  return (
    <div className="w-full text-center py-8">
      {/* Green checkmark circle - matching ConfirmationScreen icon size */}
      <div className="mb-6 flex justify-center">
        <svg className="h-16 w-16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="11" stroke="#33C6B6" strokeWidth="2" fill="none"/>
          <path d="M7 12l3 3 7-7" stroke="#33C6B6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      
      {/* Title - matching ConfirmationScreen title size */}
      <h3 className="text-2xl font-bold text-gray-900 mb-4">{title}</h3>
      
      {/* Message - matching ConfirmationScreen description size */}
      <p className="text-xl text-gray-600 mb-6 leading-relaxed max-w-2xl mx-auto px-8">{message}</p>
      
      {/* Continue button - green like start button */}
      <button
        onClick={onContinue}
        className="text-white rounded-lg px-8 py-4 text-xl font-medium transition-colors duration-200"
        style={{ backgroundColor: '#33C6B6' }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2BA89F'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#33C6B6'}
      >
        {continueButtonText}
      </button>
    </div>
  );
}

export default CompletedScreen;
